<template>
  <div v-if="!isLoading" class="detail-info">
    <section>
      <div class="detail-info-top-area">
        <div class="desc-box">
          <p class="title">{{getEpisodeTitle}}</p>
          <p class="synopsis" v-if="synopsis !== ''" v-html="synopsis"></p>
          <div class="cast">
            <table>
              <caption>출연표</caption>
              <colgroup>
                <col style="width: 34px;">
                <col>
              </colgroup>
              <tbody>
              <tr v-if="actorList.length > 0">
                <th>출연:&nbsp;</th>
                <td>
                  <div>
                    <span v-for="(actor, index) in actorList" :key="'actors_' + index">
                      {{actor.value}}{{actorList.length - 1 !== index ? ',' : ''}}
                    </span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="detail-info-bottom-area">
        <div class="poster-area">
          <img :src="programPosterImage" :alt="programTitle">
        </div>
        <div class="text-area">
          <p class="title" v-if="seasonTitle !== ''">{{ seasonTitle }}</p>
          <p class="synopsis" v-if="seasonSynopsis !== ''" v-html="seasonSynopsis"></p>

          <div class="metadata-area">
            <table>
              <caption>메타데이터표</caption>
              <colgroup>
                <col style="width: 48px;">
                <col>
              </colgroup>
              <tbody>
              <tr>
                <th>개요</th>
                <td>{{ summary }}</td>
              </tr>
              <tr v-if="tagList.length > 0">
                <th>장르</th>
                <td>
                  <span v-for="(tag, index) in tagList" :key="tag.value + index">
                    #{{tag.text}}{{tagList.length -1 !== index ? ',' : '' }}
                  </span>
                </td>
              </tr>
              <tr v-if="directorList.length > 0">
                <th>감독</th>
                <td>
                  <span v-for="(director, index) in directorList" :key="director.value + index">
                    {{director.text}}{{directorList.length - 1 !== index ? ',' : ''}}
                  </span>
                </td>
              </tr>
              <tr v-if="writerList.length > 0">
                <th>작가</th>
                <td>
                  <span v-for="(writer, index) in writerList" :key="writer.value + index">
                    {{writer.text}}{{writerList.length - 1 !== index ? ',' : ''}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CloseButtonIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
import { get } from 'lodash'
import { VodInfoService } from '@/common/api/api.service'
import { clickTag, searchByKeyword } from '@/common/util/player.util'
export default {
  name: 'ApolloVodDetailInfo',
  components: {
    CloseButtonIcon
  },
  data () {
    return {
      contentInfo: {},
      isLoading: false,
      tagList: []
    }
  },
  computed: {
    summary () {
      let { channelname = '', releasedate = '', nation = '', releaseyear = '' } = this.contentInfo
      const year = releasedate !== '' ? releasedate.substring(0, 4) : releaseyear
      const yearInfo = year.length > 0 ? `${year}년` : ''
      return [channelname, nation, yearInfo].filter(infoText => infoText !== '').join(', ')
    },
    episodeNumber () {
      return get(this.contentInfo, 'episodenumber', '').replace('회', '')
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    },
    actorList () {
      return get(this.contentInfo, 'actors.list', [])
    },
    programTitle () {
      return get(this.contentInfo, 'programtitle', '')
    },
    programPosterImage () {
      return 'https://' + get(this.contentInfo, 'programposterimage', '')
    },
    seasonTitle () {
      return get(this.contentInfo, 'seasontitle', '')
    },
    seasonSynopsis () {
      return get(this.contentInfo, 'seasonsynopsis', '')
    },
    directorList () {
      return get(this.contentInfo, 'directors.list', [])
    },
    writerList () {
      return get(this.contentInfo, 'writers.list', [])
    },
    getEpisodeTitle () {
      return this.episodeNumber ? `현재 에피소드 : ${this.episodeNumber}회` : '현재 에피소드'
    }
  },
  methods: {
    closePopup () {
      this.$router.back()
    },
    setData () {
      this.isLoading = true
      const contentID = get(this.$route, 'query.contentid', '')
      const programID = get(this.$route, 'query.programid', '')
      const setVodMetaInfo = (contentID) => {
        VodInfoService.getVodMetaInfo({ contentID }).then(({ data }) => {
          this.contentInfo = data
          const tagCount = get(this.contentInfo, ['tags', 'count'], '')
          if (tagCount === '' || tagCount === '0') {
            this.isLoading = false
            return []
          }
          let tagList = get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
            if (typeof tag === 'string') {
              return {
                text: tag,
                value: tag,
                taggroup: 'tag'
              }
            } else {
              if (tag.taggroup === undefined) {
                tag.taggroup = 'tag'
              }
              return tag
            }
          })
          this.tagList = tagList.filter((tag) => { return tag.text !== '' })
          this.isLoading = false
        }).catch(this.routerBack)
      }
      if (contentID !== '') {
        setVodMetaInfo(contentID)
      } else if (programID !== '') {
        VodInfoService.getContentIdByProgramId({ programID }).then(({ data }) => {
          setVodMetaInfo(data.contentid)
        }).catch(this.routerBack)
      }
    },
    searchByKeywordFn (keyword) {
      searchByKeyword({ keyword, isDetailInfo: true })
    },
    clickTagFn (tag) {
      clickTag({ currentSection: 'vod', tag, contentInfo: this.contentInfo })
    }
  },
  created () {
    this.setData()
  }
}
</script>
